import script from "./RcDropdownItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcDropdownItem.vue?vue&type=script&setup=true&lang=ts"

import "./RcDropdownItem.vue?vue&type=style&index=0&id=000ccd7e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-000ccd7e"]])

export default __exports__